import { useTranslation } from 'react-i18next';
import { i18nNS } from '../i18n';

const useTextGender = () => {
  const { t } = useTranslation(i18nNS.common);

  const filtersMap = {
    category: {
      name: t('common:CarFilter.FilterCategories'),
    },
    company: {
      name: t('common:CarFilter.FilterCompanies'),
    },
    categoryGroup: {
      name: t('common:CarFilter.CarCategory'),
    },
    companyGroup: {
      name: t('common:CarFilter.RentalCarCompany'),
    },
  };

  return [filtersMap];
};

export default useTextGender;
